export enum CreditCardConstantsEnum {
  EMPTY_VALUE = '',
  SPACE_VALUE = ' ',
  BID_LENGHT = 6
}
